import request from '@/api/config/request'

export function getAnos() {
    return request({
        url: `/pesquisa/anos`,
        method: 'get'
    })
}

export function getDiarios(tipo, data) {
    return request({
        url: `/pesquisa/${tipo}`,
        method: 'post',
        data
    })
}

export function getPesquisaAvancada(data) {
    return request({
        url: `/pesquisa/avancada`,
        method: 'post',
        data
    })
}

export function getCalendario(options = {}) {
    return request({
        url: `/pesquisa/calendario`,
        method: 'get',
        params: options
    })
}

